<template>
  <section v-if="showModal">
    <div class="notification">
      <div class="notification__wrap">
        <div class="notification__wrap--country">Ваша страна {{ countryIpName }}?</div>
        <div class="notification__wrap--btn">
          <div class="accept" @click="overwriteCookie(true)">Да</div>
          <div class="cancel" @click="overwriteCookie(false)">Нет</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapMutations, mapState, mapActions} from 'vuex'

export default {
  methods: {
    overwriteCookie(bool) {
      this.hiddenModalNotification()
      this.hiddenShowModel()
      if (bool) {
        let domain = this.activeCountry['domain'].trim(),
          id = this.activeCountry['id']
        window.location.href = `/auth/redirect-domain?domain=${domain}&idCountry=${id}&notification=${bool}`
      }
    },
    ...mapActions({
      locationCountryGuest: 'countryIsGuest/getCountryIsGuest',
      hiddenModalNotification: 'countryIsGuest/hiddenModalNotification',
    }),
    ...mapMutations({
      hiddenShowModel: 'countryIsGuest/hiddenShowModel',
    }),
  },
  computed: {
    activeCountry() {
      return this.listCountriesDomain.find( item => item['id'] == this.countryIpId)
    },
    ...mapState({
      showModal: state => state.countryIsGuest.countriesData.showModal,
      countryIpId: state => state.countryIsGuest.countriesData.countryIpId,
      countryIpName: state => state.countryIsGuest.countriesData.countryIpName,
      protocolHttps: state => state.countryUser.countriesData.protocolHttps,
      listCountriesDomain: state => state.countryUser.countriesData.listCountriesDomain,
    })
  },
  mounted() {
    this.locationCountryGuest()
  }
}
</script>